/**
 * @desc 查询门店区域信息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** parent_id */
  parent_id: number;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.HttpResponse>(`/storeapi/api/v3/store/areas`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
